import { ApiResult } from 'src/Libs/api'
import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchWithResponse } from 'src/Types/api'
import { DynamicEmsActivationState } from '../types'

/**
 *  Update the 'enableDynamicEms' property.
 *  This property should be set when activating / deactivating AI360v2.
 */
export const updateDynamicEmsActivationState = async (
  storageId: string | undefined,
  payload: DynamicEmsActivationState,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, boolean>> => {
  if (!storageId) {
    throw new Error('Storage ID is required to update Dynamic EMS activation state')
  }

  const response = await authFetch<void>({
    path: `storages/${storageId}/dynamic-power-price`,
    method: 'PUT',
    payload,
  })

  if (response.status !== StatusCodes.NO_CONTENT) {
    throw new UnexpectedApiResponseError(response.status)
  }

  return new ApiResult<boolean, boolean>(true, false, false)
}
